/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Goods,
    GoodsFromJSON,
    GoodsFromJSONTyped,
    GoodsToJSON,
    Measurement,
    MeasurementFromJSON,
    MeasurementFromJSONTyped,
    MeasurementToJSON,
    Price,
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
    TransportPlaceTaskType,
    TransportPlaceTaskTypeFromJSON,
    TransportPlaceTaskTypeFromJSONTyped,
    TransportPlaceTaskTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface TransportTemplateTask
 */
export interface TransportTemplateTask {
    /**
     * 
     * @type {TransportPlaceTaskType}
     * @memberof TransportTemplateTask
     */
    type?: TransportPlaceTaskType;
    /**
     * 
     * @type {string}
     * @memberof TransportTemplateTask
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof TransportTemplateTask
     */
    contactId?: string;
    /**
     * 
     * @type {Array<Goods>}
     * @memberof TransportTemplateTask
     */
    loadingGoods?: Array<Goods>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransportTemplateTask
     */
    unloadingGoods?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof TransportTemplateTask
     */
    plannedStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransportTemplateTask
     */
    plannedEnd?: Date;
    /**
     * 
     * @type {Price}
     * @memberof TransportTemplateTask
     */
    shipmentPrice?: Price;
    /**
     * 
     * @type {Array<Measurement>}
     * @memberof TransportTemplateTask
     */
    measurements?: Array<Measurement>;
}

export function TransportTemplateTaskFromJSON(json: any): TransportTemplateTask {
    return TransportTemplateTaskFromJSONTyped(json, false);
}

export function TransportTemplateTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportTemplateTask {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : TransportPlaceTaskTypeFromJSON(json['type']),
        'action': !exists(json, 'action') ? undefined : json['action'],
        'contactId': !exists(json, 'contact_id') ? undefined : json['contact_id'],
        'loadingGoods': !exists(json, 'loading_goods') ? undefined : ((json['loading_goods'] as Array<any>).map(GoodsFromJSON)),
        'unloadingGoods': !exists(json, 'unloading_goods') ? undefined : json['unloading_goods'],
        'plannedStart': !exists(json, 'planned_start') ? undefined : (new Date(json['planned_start'])),
        'plannedEnd': !exists(json, 'planned_end') ? undefined : (new Date(json['planned_end'])),
        'shipmentPrice': !exists(json, 'shipment_price') ? undefined : PriceFromJSON(json['shipment_price']),
        'measurements': !exists(json, 'measurements') ? undefined : ((json['measurements'] as Array<any>).map(MeasurementFromJSON)),
    };
}

export function TransportTemplateTaskToJSON(value?: TransportTemplateTask | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TransportPlaceTaskTypeToJSON(value.type),
        'action': value.action,
        'contact_id': value.contactId,
        'loading_goods': value.loadingGoods === undefined ? undefined : ((value.loadingGoods as Array<any>).map(GoodsToJSON)),
        'unloading_goods': value.unloadingGoods,
        'planned_start': value.plannedStart === undefined ? undefined : (value.plannedStart.toISOString()),
        'planned_end': value.plannedEnd === undefined ? undefined : (value.plannedEnd.toISOString()),
        'shipment_price': PriceToJSON(value.shipmentPrice),
        'measurements': value.measurements === undefined ? undefined : ((value.measurements as Array<any>).map(MeasurementToJSON)),
    };
}


